export default [
  {
    path: "/anonymous/proxy",
    name: "ProxyList",
    component: () => import(
      /*webpackChunkName:'anonymous'*/
      "@/views/anonymous/ProxyList.vue"),
    meta: {},
  },
  // {
  //   path: "/anonymous/proxy-log",
  //   name: "ProxyLogList",
  //   component: () => import(
  //     /*webpackChunkName:'anonymous'*/
  //     "@/views/anonymous/ProxyLogList.vue"),
  //   meta: {},
  // },
  {
    path: "/anonymous/proxy-log",
    name: "ProxyHistoryList",
    component: () => import(
      /*webpackChunkName:'anonymous'*/
      "@/views/anonymous/ProxyHistoryList.vue"),
    meta: {},
  },
]